import { Flex } from '@/components/Flex';
import { getMultiselectValue } from '@/lib/attributes';
import { getTranslatedName } from '@/lib/i18n';
import type { ShoppingBagProductWithCheckoutLineId } from '@/lib/types';

import addAStrapImage from '@/assets/addAStrapImage.png';

import * as S from './AddStrapButton.styles';
import { AddAStrap } from './messages';

export interface AddStrapButtonProps {
  iconRight?: boolean;
  onClick: () => void;
  productVariant: ShoppingBagProductWithCheckoutLineId;
}

export const AddStrapButton = ({
  iconRight = false,
  onClick,
  productVariant,
}: AddStrapButtonProps) => {
  const compatibleStrapIds = getMultiselectValue(
    productVariant.product.compatibleStraps,
  );

  if (!compatibleStrapIds.length) return null;

  const productName = getTranslatedName('name', productVariant.product);

  return (
    <S.AddButton onClick={onClick} type='button'>
      <S.ButtonContent>
        <Flex alignItems='center'>
          <S.PlusIcon />
          <S.ButtonText>{AddAStrap}</S.ButtonText>
        </Flex>
        {addAStrapImage && (
          <S.ButtonImageWrapper $iconRight={iconRight}>
            <S.ButtonImage
              alt={`${productName}.addAStrapImage`}
              fill
              sizes='10vw'
              src={addAStrapImage}
            />
          </S.ButtonImageWrapper>
        )}
      </S.ButtonContent>
    </S.AddButton>
  );
};
